
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 2.25A8.253 8.253 0 0117.114 9 8.253 8.253 0 01.886 9 8.253 8.253 0 019 2.25zm0 12A6.754 6.754 0 0015.583 9 6.754 6.754 0 002.417 9 6.754 6.754 0 009 14.25zm0-1.875a3.375 3.375 0 110-6.75 3.375 3.375 0 010 6.75zm0-1.5a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75z"}})])
          )
        }
      }
    